<template>
  <b-modal
    id="exportFieldChooser"
    class="export-field-chooser"
    centered
    scrollable
    size="lg"
    header-bg-variant="secondary">
    <template slot="modal-header">
      <h5 class="m-0">Choose Export Fields</h5>
    </template>
    <template slot="default">
      <b-container fluid>
        <b-row class="mb-1 text-center">
          <b-col cols="5">
            <h5>Available Fields</h5>
            <b-list-group>
              <b-list-group-item v-for='field in availableFields' :key='field.key' :class='{ active: field.active }' @click='field.active = !field.active'>
                {{field.name}}
              </b-list-group-item>
            </b-list-group>
          </b-col>
          <b-col cols="2">
            <b-button-group size="sm" vertical class="sticky-top">
              <b-button
                v-b-tooltip.hover.d150.nofade
                title="Unselect Fields"
                variant="primary"
                @click="unSelectFields"
              >&lt;</b-button>
              <b-button
                v-b-tooltip.hover.d150.nofade
                title="Select Fields"
                variant="primary"
                @click="selectFields"
              >&gt;</b-button>
              <b-button
                v-b-tooltip.hover.d150.nofade
                title="Unselect All Fields"
                variant="primary"
                @click="unSelectAllFields"
              >&lt;&lt;</b-button>
              <b-button
                v-b-tooltip.hover.d150.nofade
                title="Select All Fields"
                variant="primary"
                @click="selectAllFields"
              >&gt;&gt;</b-button>
            </b-button-group>
          </b-col>
          <b-col cols="5">
            <div class="sticky-top">
            <h5>Selected Fields</h5>
            <b-list-group class="export-field-list">
              <b-list-group-item v-for="field in selectedFields" :key="field.key" :class="{ active: field.active }" @click="field.active = !field.active">
                {{field.name}}
              </b-list-group-item>
            </b-list-group>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel }" style="text-align: right;">
      <b-button variant="secondary" @click="cancel()">Cancel</b-button>
      <b-button variant="primary" @click="saveAndClose">Export</b-button>
    </template>
  </b-modal>
</template>

<script>
import * as _ from 'lodash';

export default {
  name: "ExportFieldChooser",
  props: {
    fields: Array
  },
  computed: {
    availableFields: function() {
      return this.sortFields(
        this.fields.filter(function(field) {
          return !field.selected;
        })
      );
    },
    activeAvailableFields: function() {
      return this.availableFields.filter(function(field) {
        return field.active;
      });
    },
    selectedFields: function() {
      return this.sortFields(
        this.fields.filter(function(field) {
          return field.selected;
        })
      );
    },
    activeSelectedFields: function() {
      return this.selectedFields.filter(function(field) {
        return field.active;
      });
    }
  },
  methods: {
    selectFields() {
      _(this.activeAvailableFields).forEach(field => {
        field.selected = true;
      });

      this.deactivateAllFields();
    },
    selectAllFields() {
      _(this.fields).forEach(field => {
        field.selected = true;
      });

      this.deactivateAllFields();
    },
    unSelectFields() {
      _(this.activeSelectedFields).forEach(field => {
        field.selected = false;
      });

      this.deactivateAllFields();
    },
    unSelectAllFields() {
      _(this.fields).forEach(field => {
        field.selected = false;
      });

      this.deactivateAllFields();
    },
    sortFields(fieldList) {
      return fieldList.sort(function(a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        return 0;
      });
    },
    deactivateAllFields() {
      _(this.fields).forEach(field => {
        field.active = false;
      });
    },
    saveAndClose() {
        this.$emit('saveExportFields', this.fields);
        this.$emit('doExport', { selectedFields: this.selectedFields });
        this.$bvModal.hide('exportFieldChooser');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ExportFieldChooser.vue